import { render } from "./PurchasingDashboardView.vue?vue&type=template&id=112fd95e&scoped=true"
import script from "./PurchasingDashboardView.vue?vue&type=script&lang=js"
export * from "./PurchasingDashboardView.vue?vue&type=script&lang=js"

import "./PurchasingDashboardView.vue?vue&type=style&index=0&id=112fd95e&scoped=true&lang=css"

import exportComponent from "/Users/chrisfinlayson/Desktop/WORK/riverhawk-nest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-112fd95e"]])

export default __exports__